<template>
  <div class="importOrder distributorList">
    <el-form class="el-form" :inline="true" :model="listQuery" label-width="120px">
      <el-form-item label="推广链接" v-if="links.join('')">
        <el-select v-model="listQuery.linkCode" placeholder="请选择推广链接">
          <el-option :key="0" label="全部推广链接" value='' />
          <el-option
            v-for="item in allLinks"
            :key="item.promotionLinkCode"
            :label="item.promotionLinkName"
            :value="item.promotionLinkCode"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="手机号">
        <el-input
          type="text"
          v-model="listQuery.phone"
          placeholder="输入手机号查询"
          class="orderStyle numrule"
          maxLength="11"
          autocomplete="on"
        />
      </el-form-item>
      <el-form-item label="用户ID">
        <el-input
          v-model="listQuery.userId"
          placeholder="输入用户ID查询"
          class="orderStyle numrule"
          maxlength="13"
          autocomplete="on"
        />
      </el-form-item>
      <el-form-item label="创建人"  v-if="members.join('')">
        <el-select v-model="listQuery.agentCode" placeholder="请选择创建人">
          <el-option :key="0" label="全部创建人" value='' />
          <el-option
            v-for="item in members"
            :key="item.agentCode"
            :label="item.name + (item.phone ? `- ${item.phone.slice(-4)}` : '')"
            :value="item.agentCode"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="订单创建时间">
        <el-date-picker
          v-model="createTime"
          value-format="timestamp"
          type="daterange"
          :picker-options="pickerOptions"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :clearable="false"
        ></el-date-picker>
      </el-form-item>
      <el-button class="filter-item" type="primary" @click="handleSearch">查询</el-button>
      <el-button class="button-style" type="primary" icon="el-icon-plus" @click="() => dialogVisible = true">创建订单</el-button>
    </el-form>
    <el-table v-loading="listLoading" :data="list" border fit highlight-current-row style="width: 100%" :header-cell-style="tableHeader">
        <el-table-column label="推广链接ID" align="center" width="160">
          <template slot-scope="{row}">
            <span>{{ row.linkCode || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="推广链接名称" align="center" width="160">
          <template slot-scope="{row}">
            <span>{{ row.linkName || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="用户ID" align="center" min-width="90">
          <template slot-scope="{row}">
             <span>{{ row.userId || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="年级" align="center" min-width="90">
          <template slot-scope="{row}">
            <span>{{ row.grade || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="上课设备" align="center" width="120">
          <template slot-scope="{row}">
            <span>{{ row.device || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="订单号" align="center" min-width="100">
          <template slot-scope="{row}">
            <span>{{ row.orderNumber || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="订单创建时间" align="center" min-width="100">
          <template slot-scope="{row}">
            <span>{{ row.ctime ? timestampToDate(row.ctime) : '--'  }}</span>
          </template>
        </el-table-column>
        <el-table-column label="创建人" align="center" min-width="100">
          <template slot-scope="{row}">
            <span>{{ row.creator || ''  }}</span>
          </template>
        </el-table-column>
      </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="listQuery.pageNum"
      :limit.sync="listQuery.pageSize"
      @pagination="handleSearch"
    />
    <el-dialog title="创建订单" :visible.sync="dialogVisible" width="600px" :before-close="cancelDialog">
      <el-radio-group class="formType" v-model="formType" size="medium" fill="#FE9400" @change="onChangeFormType">
        <el-radio-button label="userId">已注册用户创建订单</el-radio-button>
        <el-radio-button label="phone">新用户创建订单</el-radio-button>
      </el-radio-group>
      <el-form :model="createQuery" :rules="LevelSRules" label-width="110px" ref="create">
        <el-form-item
          prop="userId"
          label="userID："
          v-if="formType === 'userId'"
          :rules="userIDRule"
        >
          <el-input
            type="text"
            v-model.number="createQuery.userId"
            @change="onChangeUserId"
            placeholder="输入userId"
            class="orderStyle numrule"
            autocomplete="on"
          />
        </el-form-item>
        <el-form-item
          prop="phone"
          label="用户手机号："
          v-if="formType === 'phone'"
          :rules="phoneRule"
        >
          <el-input
            type="text"
            v-model="createQuery.phone"
            placeholder="输入手机号"
            class="orderStyle numrule"
            maxLength="11"
            autocomplete="on"
          />
        </el-form-item>
        <el-form-item prop="linkCode" label="推广链接：" v-if="enableLinks.join('')">
          <el-select v-model="createQuery.linkCode" placeholder="请选择推广链接">
            <el-option
              v-for="item in enableLinks"
              :key="item.promotionLinkCode"
              :label="item.promotionLinkName"
              :value="item.promotionLinkCode"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="年级：" prop="grade">
          <el-radio v-model="createQuery.grade" label="一年级" border>一年级</el-radio>
          <el-radio v-model="createQuery.grade" label="二年级" border>二年级</el-radio>
          <el-radio v-model="createQuery.grade" label="三年级" border>三年级</el-radio>
          <el-radio v-model="createQuery.grade" label="四年级" border>四年级</el-radio>
          <el-radio v-model="createQuery.grade" label="五年级" border>五年级</el-radio>
          <el-radio v-model="createQuery.grade" label="六年级" border>六年级</el-radio>
        </el-form-item>
        <el-form-item label="上课设备：" prop="device">
          <el-radio v-model="createQuery.device" label="笔记本电脑">笔记本电脑</el-radio>
          <el-radio v-model="createQuery.device" label="台式电脑">台式电脑</el-radio>
          <el-radio v-model="createQuery.device" label="苹果iPad">苹果iPad</el-radio>
        </el-form-item>
      </el-form>
      <div class="userError" v-if="userError">非正式用户userID，重新确认userID，或使用手机号生成订单</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelDialog">取 消</el-button>
        <el-button type="primary" :loading="createBtnLoading" @click="confirmDialog">创 建</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getLinkList } from '@/services/link';
import { getAgentManualOrders, setAgentManualOrders } from '@/services/order';
import { getMemberList } from '@/services/member';
import Pagination from "@/components/Pagination/index";
import { getTeamCode, getAgentCode, getTeamRole, getAgentName } from '@/utils/auth';
import { optionTrim, timestampToDateTotal } from "@/utils/utils";

export default {
  name: 'ImportOrder',
  components: {
    Pagination
  },
  data() {
    return {
      formType: 'userId',
      total: 0,
      list: [],
      links: [],
      allLinks: [],
      members: [],
      listQuery: {
        pageNum: 1,
        pageSize: 10,
        linkCode: '',
        agentCode: ''
      },
      userError: false,
      createQuery: {},
      listLoading: false,
      dialogVisible: false,
      createBtnLoading: false,
      teamRole: getTeamRole() ? Number(getTeamRole()) : 0,
      teamCode: getTeamCode(),
      agentCode: getAgentCode(),
      createTime: [new Date().getTime() - 3600 * 1000 * 24 * 30, new Date().getTime()],
      pickerOptions: {
        shortcuts: [
          {
            text: "今日",
            onClick(picker) {
              const end = new Date();
              const start = new Date(new Date().setHours(0, 0, 0, 0));
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "昨日",
            onClick(picker) {
              const start = new Date();
              start.setTime(start.getTime() - 24 * 60 * 60 * 1000);
              start.setHours(0, 0, 0, 0);
              const end = new Date();
              end.setTime(end.getTime() - 24 * 60 * 60 * 1000);
              end.setHours(23, 59, 59, 0);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "本周",
            onClick(picker) {
              const end = new Date();
              const week = end.getDay();
              const millisecond = 1000 * 60 * 60 * 24;
              const minusDay = week !== 0 ? week - 1 : 6;
              const monday = new Date(end.getTime() - minusDay * millisecond);
              const start = new Date(monday);
              start.setHours(0, 0, 0, 0);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "上周",
            onClick(picker) {
              // 上周开始时间
              const starta = new Date();
              var first = starta.getDate() - starta.getDay() - 6;
              var startDate = new Date(starta.setDate(first));
              const start = new Date(startDate);
              start.setHours(0, 0, 0, 0);
              //  上周结束时间
              var currentDate = new Date();
              var firsts = currentDate.getDate() - currentDate.getDay() - 6;
              var last = firsts + 6;
              var endDate = new Date(currentDate.setDate(last));
              const end = new Date(endDate);
              end.setHours(23, 59, 59, 0);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "本月",
            onClick(picker) {
              const currentDate = new Date();
              const currentMonth = currentDate.getMonth();
              const currentYear = currentDate.getFullYear();
              const start = new Date(currentYear, currentMonth, 1);
              const end = new Date();
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "上月",
            onClick(picker) {
              const start = new Date();
              const end = new Date();
              const m = start.getMonth() - 1;
              start.setDate(1);
              start.setMonth(m);
              end.setDate(0);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: '最近一周',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近一个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近三个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ],
        onPick: obj => {
          this.pickerMinDate = new Date(obj.minDate).getTime();
        },
      },
      LevelSRules: {
        linkCode: [
          {
            required: true,
            message: "请选择推广链接",
            trigger: ['blur']
          }
        ],
        grade: [
          {
            required: true,
            message: "请选择年级",
            trigger: ['change'],
          }
        ],
        device: [
          {
            required: true,
            message: "请选择上课设备",
            trigger: 'change'
          }
        ]
      },
      userIDRule: [
        {
          required: true,
          message: 'userID不能为空'
        },
        {
          type: 'number',
          message: 'userID必须为数字值'
        }
      ],
      phoneRule: [
        {
          required: true,
          message: "请输入手机号",
          trigger: ['blur']
        },
        {
          validator: (rule, val, cb) => {
            const reg = /^1[3-9]\d{9}$/;
            if (!reg.test(val)) {
              cb(new Error('请输入正确的手机号'))
            } else {
              cb()
            };
          },
          trigger: ['blur']
        }
      ]
    }
  },
  computed: {
    tableHeader() {
      return () => {
        return { 'background-color': '#f5f5f5' }
      }
    },
    enableLinks() {
      return this.links.filter((o) => o.linkStatus === 1)
    }
  },
  created() {
    this.getLinkList();
    this.getLinkList(true);
    this.getMemberList();
    this.handleSearch();
  },
  methods: {
    timestampToDate: t => timestampToDateTotal(t),
    onChangeUserId() {
      this.userError = false;
    },
    async getLinkList(all = false) {
      const { teamRole, teamCode, agentCode } = this;
      const params = {
        pageNumber: 1,
        pageSize: 10000,
        teamCode,
        agentCode,
        teamRole,
        showDeleted: all,
      }
      const links = await getLinkList(params);
      const { errCode, data } = links.data;
      if (errCode === 0) {
        if (all) {
          this.allLinks = data.list;
        } else {
          this.links = data.list;
        }
      }
    },
    async getMemberList() {
      const { teamRole, teamCode, agentCode } = this;
      if (teamRole === 0) {
        // 接口没有添加用户权限处理，暂时只能前端过滤
        this.members = [{
          agentCode: agentCode,
          name: getAgentName(),
        }]
      } else {
        const members = await getMemberList({ teamCode });
        const { errCode, errMsg, data } = members.data;
        if (errCode === 0) {
          this.members = data;
        } else {
          if (errMsg) this.$message({ type: 'error', message: errMsg });
        }
      }
    },
    async handleSearch() {
      this.listLoading = true;
      const { listQuery, createTime } = this;
      const [ctimeBegin, ctimeEnd] = createTime;
      Object.assign(listQuery, {
        ctimeBegin,
        ctimeEnd
      });
      const orders = await getAgentManualOrders({
        type: 'POST',
        params: optionTrim(listQuery)
      });
      console.log('orders ', orders);
      const {
        errCode,
        errMsg,
        data,
      } = orders.data;
      const { list, total } = data || {};
      if (errCode === 0) {
        Object.assign(this, {
          list,
          total
        });
      } else {
        if (errMsg) this.$message({ type: 'error', message: errMsg });
        Object.assign(this, {
          list: [],
          total: 0
        });
      }
      this.listLoading = false;
    },
    cancelDialog() {
      this.createQuery = {};
      this.userError = false;
      this.dialogVisible = false;
      this.$refs.create.clearValidate();
      this.formType = 'userId';
    },
    onChangeFormType() {
      this.userError = false;
      this.$refs.create.clearValidate();
    },
    async confirmDialog() {
      const validate = await this.$refs.create.validate();
      const { createQuery, links, formType } = this;
      const link = links.find(l => l.promotionLinkCode === createQuery.linkCode);
      let form = createQuery;
      if (formType === 'phone') {
        const { userId, ...data } = createQuery;
        form = data;
      } else if (formType === 'userId') {
        const { phone, ...data } = createQuery;
        form = data;
      }
      const params = {
        ...form,
        linkName: link?.promotionLinkName
      }
      this.createBtnLoading = true;
      console.log(' == 创建验证通过 ', validate, params)
      try {
        const create = await setAgentManualOrders({
          type: "POST",
          params
        });
        const { errCode, errMsg } = create.data
        if (errCode === 0) {
          this.$message({ type: 'success', message: "创建成功" });
          this.handleSearch();
          this.cancelDialog();
        } else if (errCode === 4009) {
          this.userError = true;
        } else {
          this.$message({ type: 'error', message: errMsg });
        }
      } catch (error) {
        this.$message({ type: 'error', message: '网络异常，请检查网络' });
      }
      this.createBtnLoading = false;
    }
  }
}
</script>

<style lang="less">
@import '../../styles/common.less';
.importOrder {
  .el-form{
    position: relative;
  }
  &.distributorList{
    .filter-item {
      margin-right: 132px;
    }
    .button-style{
      bottom: 28px;
      top: auto;
      right: 10px;
    }
  }
  .formType {
    padding-bottom: 20px;
    .el-radio-button__inner:hover{
      color: #FE9400;
    }
    .is-active {
      .el-radio-button__inner:hover{
        color: #fff;
      }
    }
  }
  .userError{
    padding-left: 110px;
    color:red;
  }
  .el-radio, .el-radio.is-bordered+.el-radio.is-bordered{
    margin: 0 20px 20px 0;
  }
  .el-radio.is-bordered.is-checked{
    border-color: #FE9400;
    color: #FE9400;
  }
  .el-radio__input.is-checked .el-radio__inner{
    border-color: #FE9400;
    background: #FE9400;
  }
  .el-radio__input.is-checked+.el-radio__label{
    color: #FE9400;
  }
}
</style>
